import { configureStore } from "@reduxjs/toolkit";

import contactFormReducer from "../features/contactForm/contactFormSlice";
import shopPageReducer from "../features/shopPage/shopPageSlice.js";
import cartSidebarReducer from "../features/cartSidebar/cartSidebarSlice.js";
import shippingFormReducer from "../features/shippingForm/shippingFormSlice.js";
import { api } from "../services/api";

export const store = configureStore({
    reducer: {
        contactForm: contactFormReducer,
        shopPage: shopPageReducer,
        cartSidebar: cartSidebarReducer,
        shippingForm: shippingFormReducer,
        [api.reducerPath]: api.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
});